import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./WebsiteDevelopmentDubai.css";

function WebsiteDevelopmentDubai() {
  const navigate = useNavigate();

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do you provide website development services in Dubai?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. SamSoftix provides professional website development services for businesses in Dubai and across the UAE with remote collaboration and international standards."
        }
      },
      {
        "@type": "Question",
        "name": "How much does website development cost in Dubai?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Website development costs in Dubai depend on project scope and features. Contact us for a customized quote in AED."
        }
      },
      {
        "@type": "Question",
        "name": "Will my website rank on Google UAE?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. We build SEO-optimized websites structured to rank on Google UAE and competitive Dubai markets."
        }
      }
    ]
  };

  return (
    <main className="dubai-page">
      <Helmet>
        <title>Website Development Company in Dubai | Web Design UAE | SamSoftix</title>
        <meta
          name="description"
          content="Looking for website development in Dubai? SamSoftix builds high-performance, SEO-optimized business websites for companies across Dubai and UAE."
        />
        <meta
          name="keywords"
          content="Website development Dubai, Web design company Dubai, Website developers UAE, SEO website Dubai"
        />
        <link rel="canonical" href="https://www.samsoftix.com/Dubai_Website_Service_SamSoftix" />
        <meta property="og:title" content="Website Development Company in Dubai | SamSoftix" />
        <meta property="og:description" content="Professional website development services for Dubai businesses. SEO-optimized, fast and secure websites." />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_AE" />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      {/* Hero Section */}
      <section className="dubai-hero">
        <h1>Website Development Company in Dubai</h1>
        <p>
          We help Dubai businesses build powerful, modern and SEO-optimized 
          websites that increase visibility, leads and sales across the UAE market.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="dubai-btn">
          Get Free Consultation (Dubai)
        </button>
      </section>

      {/* Why Choose Us */}
      <section className="dubai-section">
        <h2>Why Dubai Businesses Choose SamSoftix</h2>
        <ul>
          <li>✔ SEO-Optimized for Google UAE</li>
          <li>✔ Modern UI/UX for competitive Dubai market</li>
          <li>✔ Mobile-first responsive development</li>
          <li>✔ Fast-loading & secure websites</li>
          <li>✔ E-commerce & corporate solutions</li>
          <li>✔ Flexible remote collaboration</li>
        </ul>
      </section>

      {/* Business Impact */}
      <section className="dubai-section">
        <h2>Grow Your Business in Dubai with a Professional Website</h2>
        <p>
          Dubai is one of the most competitive digital markets in the Middle East.
          A professionally developed website improves brand trust, generates
          qualified leads, and strengthens your online presence in UAE.
        </p>
      </section>

      {/* Services Included */}
      <section className="dubai-section">
        <h2>Our Website Development Services in Dubai</h2>
        <ul>
          <li>Corporate Website Development</li>
          <li>E-commerce Website Development</li>
          <li>Landing Pages for Lead Generation</li>
          <li>Custom Web Applications</li>
          <li>Website Redesign & Optimization</li>
        </ul>
      </section>

      {/* Process */}
      <section className="dubai-section">
        <h2>Our Development Process</h2>
        <ol>
          <li>Market & Competitor Research (Dubai Industry)</li>
          <li>UX Strategy & Wireframing</li>
          <li>Development with SEO Structure</li>
          <li>Testing & Performance Optimization</li>
          <li>Launch & Ongoing Support</li>
        </ol>
      </section>

      {/* FAQ */}
      <section className="dubai-section">
        <h2>Frequently Asked Questions</h2>

        <h3>Do you work with Dubai startups and enterprises?</h3>
        <p>Yes. We work with startups, SMEs and corporate businesses across UAE.</p>

        <h3>Can you integrate payment gateways in UAE?</h3>
        <p>Yes. We integrate secure UAE-supported payment gateways and e-commerce systems.</p>

        <h3>Do you provide maintenance?</h3>
        <p>Yes. We offer monthly website maintenance and SEO support plans.</p>
      </section>

      {/* CTA */}
      <section className="dubai-cta">
        <h2>Ready to Build Your Website in Dubai?</h2>
        <p>
          Let SamSoftix help you stand out in Dubai’s competitive digital landscape.
        </p>
        <button onClick={() => navigate("/serviceBooking")} className="dubai-btn">
          Start Your Dubai Project
        </button>
      </section>
    </main>
  );
}

export default WebsiteDevelopmentDubai;